import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Tooltip } from "@mui/material";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function RecipeSelector(props) {
  const [allRecipes, setAllRecipes] = React.useState([]);
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // On autofill we get a stringified value.
    const returnValue = typeof value === "string" ? value.split(",") : value;

    if (props.index === undefined) {
      props.setSelectedRecipes(returnValue);

      //Wenn kein Rezept ausgewählt wurde, dann soll Szenario auf inaktiv gesetzt werden
      if (returnValue.length === 0) {
        props.setActive(false);
      }
    } else {
      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/scenario/setRecipes/" +
          props.id,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(returnValue),
        }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Unable to access endpoint: scenario/setRecipes");
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          props.setSelectedRecipes((prev) => {
            let temp = JSON.parse(JSON.stringify(prev));
            temp[props.index].recipes = returnValue;
            if (returnValue.length === 0) temp[props.index].active = false;
            return temp;
          });
          setGlobalMessage({
            globalMessage: "Änderung erfolgreich",
            severity: "success",
          });
        })
        .catch((error) => {
          setGlobalMessage({
            globalMessage: "Vorgang fehlgeschlagen",
            severity: "error",
          });
        });
    }
  };

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/recipe/getAll",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setAllRecipes(data);
      })
      .catch((error) => {});
  }, []);

  return (
    <div>
      <FormControl sx={{ width: props.width }} size="small">
        <InputLabel id="demo-multiple-checkbox-label">
          Mögliche Rezepturen
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={props.selectedRecipes}
          onChange={(e) => handleChange(e)}
          input={<OutlinedInput label="Mögliche Rezepturen" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {props.selectedRecipes.map((recipe) => (
            <MenuItem key={recipe} value={recipe}>
              <Checkbox checked={props.selectedRecipes.indexOf(recipe) > -1} />
              <Tooltip title={recipe} enterDelay={1000}>
                <ListItemText primary={recipe} />
              </Tooltip>
            </MenuItem>
          ))}

          {allRecipes.map((recipe) =>
            props.selectedRecipes.indexOf(recipe.title) <= -1 ? (
              <MenuItem key={recipe.title} value={recipe.title}>
                <Checkbox checked={false} />
                <Tooltip title={recipe.title} enterDelay={1000}>
                  <ListItemText primary={recipe.title} />
                </Tooltip>
              </MenuItem>
            ) : null
          )}
        </Select>
      </FormControl>
    </div>
  );
}
